









import { Component, Prop, Vue } from 'vue-property-decorator';

// Three-state icon for per-worker pipeline steps on the Workers tab. The
// component understands three combinations:
//   done=true              → green tick
//   done=false + error     → red exclamation (tooltip shows the error)
//   done=false (no error)  → grey outline (tooltip says "not yet…")
@Component({ name: 'StepStateIcon' })
export default class extends Vue {
    @Prop({ required: true }) done!: boolean;
    @Prop({ default: '' }) error!: string;
    @Prop({ default: '' }) doneTooltip!: string;
    @Prop({ default: '' }) pendingTooltip!: string;

    get iconColor(): string {
        if (this.done) return 'success';
        if (this.error) return 'error';
        return 'grey';
    }

    get iconName(): string {
        if (this.done) return 'mdi-check-circle';
        if (this.error) return 'mdi-alert-circle';
        return 'mdi-circle-outline';
    }

    get tooltipText(): string {
        if (this.done) return this.doneTooltip || 'Done';
        if (this.error) return this.error;
        return this.pendingTooltip || 'Pending';
    }
}
